<template>
    <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
            <h2 class="text-lg font-semibold text_color">Select your WhatsApp account vendor</h2>
            <p class="text-sm secondary_color">
                Select the vendor you want to use for managing your templates, phone numbers and messaging.    
            </p>
        </div>

        <div class="flex justify-start">
            <div class="max-w-lg">
                <VendorCard
                    v-for="vendor in vendors"
                    :key="vendor.id"
                    :vendor="vendor"
                    :is-selected="selectedVendor === vendor.id"
                    @select="selectVendor"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import VendorCard from "@/src/components/whatsapp/VendorCard.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
    selectedVendor: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(["update:selectedVendor"]);

const selectedVendor = ref(props.selectedVendor);

watch(() => props.selectedVendor, (newValue) => {
    selectedVendor.value = newValue;
});

const vendors = [
    {
        id: "msg91",
        name: "MSG91",
        icon: imageNames.MSG_91_ICON,
        iconBgClass: "",
    },
];

const selectVendor = (vendorId) => {
    if (selectedVendor.value === vendorId) {
        selectedVendor.value = null;
        emit("update:selectedVendor", null);
    } else {
        selectedVendor.value = vendorId;
        emit("update:selectedVendor", vendorId);
    }
};

// Expose method for parent component validation
const validateBeforeNext = () => {
    if (!selectedVendor.value) {
        return false;
    }
    return true;
};

defineExpose({
    validateBeforeNext,
});
</script>

<style scoped>
.vendor-card {
    min-height: 150px;
}
</style>

